import { render } from "./CommonTable.vue?vue&type=template&id=7b505d64"
import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"

import "./CommonTable.vue?vue&type=style&index=0&id=7b505d64&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__